import { Region } from '../region';
import { IPaymentProvider } from '../../providers/payment/payment.interface'
import { PaymentProviderCyberSource } from '../../providers/payment/payment.cybersource';

/**
 * @description Geographical region the application is currently configured for, e.g. US, Spain, Australia.
 * @region Enumeration for this region.
 * @defaultCountryFrom Default value to use for send-from country, i.e. in price calculator
 * @defaultCurrencyFrom Default value to use for send-from currency, i.e. in price calculator
 * @defaultLanguage Default language culture to use, i.e. content translations
 */
export const regionValues = {
  region: Region.LT,
  regionId: 11311,
  defaultCountryFrom: 'LT',
  defaultCountryFromOnfido: 'LTU',
  defaultCountryCodeFrom: 370,
  defaultCurrencyFrom: 'EUR',
  defaultLanguageCulture: 'lt-LT',
  defaultLocation: {
    latitude: 54.6872,
    longitude: 25.2797
  },
  dateFormat: 'YYYY/MM/DD',
  postalCodeRegex:`^([Ll][Tt][- ]?)?\\d{5}$`,
  links: {
    linkFaq: 'https://www.riamoneytransfer.com/us/en/mobile-content/faqs'
  },
  languageCultures: ['lt-LT', 'en-LT'],
  regionalIp: '66.82.123.234',
  paymentProvider: <IPaymentProvider>new PaymentProviderCyberSource(),
  isPlaidEnabled: false,
  isBankAccountEnabled:false,
  useSecurityQuestions: false,
  oldRemittanceLogin: false,
  onfidoMaxAttempts: 1,
  directBankBrand:'',
  distanceMetric: 'km',
  acceptInternationalCards:true,
  stagedRiaBrand: '',
  payNearMeBrand: '',
  isEu: true,
  isEMEA: true,
  notShowMarketingPushAlert: false,
  useVeriff: false,
  googlepayAdyenPaymentNetworks: ["masterCard", "visa"],
  applepayAdyenPaymentNetworks: ["cartes_bancaires", "masterCard", "visa"],
  adyenMerchantCapability: ["debit", "3ds", "credit"],
  walletSettings:{
    isMerchantSupportEnable:false,
  },
  defaultTranslationParams: null,
  originalCountryAllowedOnly: false,
  canShowLogosOnQRScanner: false,
  airtimeServices:{
    isAirTimeSevice:false,
    isLocalOnly:false,
  },
  passCodeLength: 6,
  walletServices:[],
  isCountrySupportDecimal: true,
  showNewHomePage: true,
  autoEnableMarketingPreference: false,
  loginRootHomePage: "activity",
  adyenRegion: 'live'// https://docs.adyen.com/development-resources/live-endpoints/#client-side-environment-region
};



// WEBPACK FOOTER //
// ./src/environment/region/LT.ts